import ParentDialogMobile from './parent_dialog_mobile';
import ParentDialogTv from './parent_dialog_tv';

export { ParentDialogMobile, ParentDialogTv };
